// eslint-disable

import { useQuery } from '@tanstack/react-query'
import { Pagination } from 'src/components/datagrid'
import { IProductItem } from 'src/types/product'

import axiosInstance from 'src/utils/axios'

type Products = {
  data: IProductItem[]
  page: number
  perPage: number
  totalPages: number
  total: number
}

async function fetchUser(pagination: Pagination, filters: any): Promise<Products> {
  let sortName: any = 'createdAt'
  let order: string = 'desc'

  if (pagination.sort) {
    const keyNames = Object.keys(pagination.sort)
    sortName = keyNames[0]
    order = pagination.sort[sortName]
  }

  const res = await axiosInstance.get('/product', {
    params: {
      ...pagination,
      ...filters,
      sort: sortName,
      order: order === 'desc' ? -1 : 1,
      categories: filters?.categories
        ? filters?.categories.map((cat: any) => JSON.parse(cat).value)
        : '',
    },
  })

  return res.data
}

function useProducts(pagination: Pagination, filters?: any) {
  return useQuery(['products', pagination, filters], () => fetchUser(pagination, filters), {
    keepPreviousData: true,
    staleTime: 5000,
  })
}

export default useProducts
